/**
 * Static HTML templates injected once at app startup.
 * Dynamic content is updated via DOM patching, never via re-render.
 */
export const templates = {
  home: /* html */ `
    <div id="page-home" class="page">
      <div class="home__logo">
        <span class="logo-emoji">💣</span>
        <h1>数字炸弹</h1>
        <p>直播间互动竞猜小游戏</p>
      </div>

      <div class="home__form glass-panel">
        <div class="form-group">
          <label for="input-room-name">🎬 直播间名称</label>
          <input id="input-room-name" value="sk693" class="input" type="text" placeholder="一份直播间名称" maxlength="24" autocomplete="off" />
        </div>
        <div class="form-group">
          <label for="input-room-id">🔑 直播间房间号</label>
          <input id="input-room-id" value="964822034136" class="input" type="text" placeholder="联系管理获取方法" maxlength="24" autocomplete="off" />
        </div>
        <button id="btn-enter" class="btn btn--primary">进入游戏 🎮</button>
      </div>

      <div class="home__nav">
        <button id="btn-home-to-about" class="btn btn--ghost">关于 &amp; 更新日志</button>
      </div>
    </div>
  `,

  game: /* html */ `
    <div id="page-game" class="page">

      <!-- ══ NORMAL MODE ════════════════════════════════════════ -->
      <div id="normal-view">
        <!-- Header -->
        <header class="game-header">
          <div class="game-header__left">
            <span class="badge badge--blue">💣 数字炸弹</span>
            <span class="game-header__room" id="header-room-label">—</span>
          </div>
          <div class="game-header__right">
            <div class="ws-status">
              <div class="ws-dot" id="ws-dot"></div>
              <span id="ws-label">未连接</span>
            </div>
            <button id="btn-compact-on" class="btn btn--ghost btn--sm" title="切换直播间紧凑模式">📺 直播模式</button>
            <button id="btn-game-to-home" class="btn btn--ghost btn--sm">← 返回</button>
          </div>
        </header>

        <!-- Body -->
        <main class="game-body">
          <!-- Left column (scrollable on PC, normal flow on mobile) -->
          <div class="game-body__left">
            <!-- Vote chart -->
            <section class="vote-section glass-panel">
              <div class="section-title">
                <span class="vote-dot"></span>
                弹幕热门数字投票
              </div>
              <div id="vote-chart"></div>
              <div class="vote-hint" id="vote-hint">游戏开始后自动接收弹幕数字</div>
              <div class="demo-banner" id="demo-banner">⚠️ 未连接 WebSocket，已启用模拟弹幕模式</div>
            </section>

            <!-- Range -->
            <section class="range-display glass-panel">
              <div>
                <div class="range-display__num" id="range-min">1</div>
                <div class="range-display__label">最小</div>
              </div>
              <div class="range-display__sep">～</div>
              <div>
                <div class="range-display__num" id="range-max">100</div>
                <div class="range-display__label">最大</div>
              </div>
              <div class="range-display__called">
                <div class="range-display__called-num" id="called-count">0</div>
                <div class="range-display__called-label">已报数</div>
              </div>
            </section>

            <!-- Number grid -->
            <section class="grid-section glass-panel">
              <div class="section-title">🎯 点击数字报数</div>
              <div class="number-grid" id="number-grid"></div>
            </section>

            <!-- Manual input -->
            <div class="call-row">
              <input
                id="call-input"
                class="input"
                type="number"
                min="1" max="100"
                placeholder="输入报数（1-100）"
              />
              <button id="btn-call-number" class="btn btn--primary" disabled>报数 ✋</button>
            </div>
          </div>

          <!-- Right column: history -->
          <section class="history-section glass-panel">
            <div class="section-title">📜 报数记录</div>
            <div class="history-list" id="history-list"></div>
          </section>
        </main>

        <!-- Status bar -->
        <footer class="game-status-bar">
          <span class="status-text" id="status-text">⏸ 等待开始 — 点击「开始新一局」</span>
          <div class="status-bar__actions">
            <button id="btn-new-game" class="btn btn--success btn--sm">▶ 开始新一局</button>
            <button id="btn-game-to-about" class="btn btn--ghost btn--sm">关于</button>
          </div>
        </footer>
      </div>

      <!-- ══ COMPACT / STREAMING MODE ═══════════════════════════ -->
      <div id="compact-view" class="compact-view" style="display:none">
        <!-- Mini header bar -->
        <div class="cv-header">
          <span class="cv-title">💣 数字炸弹</span>
          <div class="cv-header-right">
            <div class="ws-status">
              <div class="ws-dot" id="cv-ws-dot"></div>
              <span id="cv-ws-label">未连接</span>
            </div>
            <button id="btn-compact-off" class="btn btn--ghost btn--sm">✕ 退出直播模式</button>
          </div>
        </div>

        <!-- Main compact panel -->
        <div class="cv-body">
          <!-- Left: vote + grid + input -->
          <div class="cv-main">
            <!-- Vote bar -->
            <div class="cv-vote glass-panel">
              <div class="cv-vote__title">
                <span class="vote-dot"></span>弹幕热门
              </div>
              <div id="cv-vote-chart"></div>
            </div>

            <!-- Range pill -->
            <div class="cv-range glass-panel">
              <span class="cv-range__num" id="cv-range-min">1</span>
              <span class="cv-range__sep">～</span>
              <span class="cv-range__num" id="cv-range-max">100</span>
              <span class="cv-range__called"><span id="cv-called-count">0</span> 轮</span>
            </div>

            <!-- Number grid -->
            <div class="cv-grid-wrap glass-panel">
              <div class="number-grid" id="cv-number-grid"></div>
            </div>

            <!-- Input + new game -->
            <div class="cv-actions">
              <input id="cv-call-input" class="input cv-input" type="number" min="1" max="100" placeholder="报数…" />
              <button id="cv-btn-call" class="btn btn--primary cv-btn" disabled>报数</button>
              <button id="cv-btn-new" class="btn btn--success cv-btn">▶ 新一局</button>
            </div>

            <div class="cv-status" id="cv-status-text">⏸ 等待开始</div>
          </div>
        </div>
      </div>

    </div>
  `,

  about: /* html */ `
    <div id="page-about" class="page">
      <div class="about__header">
        <h2>💣 关于数字炸弹</h2>
        <p>直播间互动竞猜小游戏</p>
      </div>

      <article class="about__section glass-panel">
        <h3>👨‍💻 关于我</h3>
        <p>
          嗨，大家好！我是 **Yunus**，一名前端出身的全栈开发者，专注于打造高质量且具有良好用户体验的产品。
          我热衷于探索现代 Web 技术，也关注设计与开发之间的平衡。
        </p>
        <p>
          平时我会做一些有趣的小项目，分享开发经验和技术思考。如果你对项目有想法、想交流技术，
          或者只是想聊聊，都可以点击【<a href="https://home.nofuzz.cn/">这里</a>】找到我。
        </p>
      </article>

      <article class="about__section glass-panel">
        <h3>🎮 玩法说明</h3>
        <ul>
          <li>系统随机选定 1~100 中的一个数字作为「炸弹」，全程保密</li>
          <li>主播与观众轮流报数，必须在当前有效范围内，不能重复</li>
          <li>每次报数后范围自动缩小至包含炸弹的区间</li>
          <li>谁报出恰好是炸弹的数字，即踩雷出局，本轮结束</li>
          <li>顶部投票栏实时显示弹幕中最热门的前三个数字</li>
        </ul>
      </article>

      <article class="about__section glass-panel">
        <h3>📺 直播模式</h3>
        <p>点击「直播模式」切换为紧凑布局，将数字格、投票栏和开局按钮压缩在一个区域内，适合作为 OBS/直播软件的浏览器源叠加显示。</p>
      </article>

      <article class="about__section glass-panel">
        <h3>📋 更新日志</h3>
        <ul class="changelog">
          <li>
            <span class="version">v1.3.0</span>
            <div>
              <div class="log-text">新增直播间紧凑模式；修复 PC 端数字格截断；强化已报数字视觉区分</div>
              <div class="log-date">2026-04-23</div>
            </div>
          </li>
          <li>
            <span class="version">v1.2.0</span>
            <div>
              <div class="log-text">重构为 Vite + TypeScript 模块化工程，拆分 game / components / pages 层</div>
              <div class="log-date">2026-04-23</div>
            </div>
          </li>
          <li>
            <span class="version">v1.1.0</span>
            <div>
              <div class="log-text">新增 ECharts 实时投票图表 + Frutiger Aero 玻璃态 UI 重设计</div>
              <div class="log-date">2026-04-21</div>
            </div>
          </li>
          <li>
            <span class="version">v1.0.0</span>
            <div>
              <div class="log-text">初始版本 — 核心游戏逻辑 + WebSocket 弹幕投票</div>
              <div class="log-date">2026-04-21</div>
            </div>
          </li>
        </ul>
      </article>

      <nav class="about__nav">
        <button id="btn-about-to-home" class="btn btn--ghost">← 返回首页</button>
        <button id="btn-about-to-game" class="btn btn--primary">进入游戏 🎮</button>
      </nav>
    </div>
  `,
}
